<script setup lang="ts">
/* Duplicated in FV */
import { computed, onMounted } from 'vue'

const HeadwayWidgetClassName = 'HW_widget_component'
const HeadwayWidgetSelector = '.' + HeadwayWidgetClassName
const HeadwayWidgetTriggerClassName = 'HW_trigger'
const HeadwayWidgetTriggerSelector = '.' + HeadwayWidgetTriggerClassName

interface Props {
  id: string
  account: string
}

const props = defineProps<Props>()

const className = computed<string>(() => HeadwayWidgetClassName + `_${props.id}`)

declare const window: {
  Headway: {
    getNewWidget: () => {
      init: (config: object) => void
    }
  }
} & Window

onMounted(() => {
  if (window.Headway) {
    initHeadway()
  } else {
    const head = document.getElementsByTagName('head')[0]
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.onload = () => {
      initHeadway()
    }
    script.src = 'https://cdn.headwayapp.co/widget.js'
    head.appendChild(script)
  }
})

function initHeadway(): void {
  // More properties exist - see https://docs.headwayapp.co/widget
  const hwConfig = {
    selector: HeadwayWidgetSelector + `_${props.id}`,
    account: props.account,
    trigger: HeadwayWidgetTriggerSelector + `_${props.id}`,
    // Undocumented prop, affects the positioning of the dot that triggers the widget
    badgePosition: 'center',
  }
  const widget = window.Headway.getNewWidget()
  widget.init(hwConfig)
}
</script>

<template>
  <div
    class="relative inline-block"
    :class="className"
  >
    <slot />
  </div>
</template>

<style></style>
